import { render, staticRenderFns } from "./RideForm.vue?vue&type=template&id=45e53d8e"
import script from "./RideForm.vue?vue&type=script&lang=js"
export * from "./RideForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports